import { z } from 'zod';
export const destekDurumu = z.enum(['ACIK', 'CEVAP_BEKLIYOR', 'COZULDU', 'KAPATILDI']);
export const destekMesaji = z.object({
    id: z.string(),
    talepId: z.string(),
    govde: z.string(),
    yazanTipi: z.string(),
    yazanId: z.string().nullable().optional(),
    yazanAdSoyad: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const destekTalebi = z.object({
    id: z.string(),
    musteriId: z.string().nullable().optional(),
    musteriAdSoyad: z.string().nullable().optional(),
    telefon: z.string(),
    konu: z.string(),
    aciklama: z.string(),
    durum: destekDurumu,
    oncelik: z.number().int(),
    atananKullaniciId: z.string().nullable().optional(),
    atananAdSoyad: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
    guncellemeTarihi: z.string().datetime(),
    mesajSayisi: z.number().int().optional(),
});
export const destekTalebiDetay = destekTalebi.extend({
    mesajlar: z.array(destekMesaji),
});
export const destekSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(50),
    durum: destekDurumu.optional(),
    arama: z.string().optional(),
});
export const destekDurumGuncelleIstegi = z.object({
    durum: destekDurumu,
});
export const destekMesajEkleIstegi = z.object({
    govde: z.string().trim().min(1).max(5000),
});
//# sourceMappingURL=destek.js.map